<div width="100%" height="100%" class="">
  <img *ngIf="src" [src]="src" (error)="updateUrl($event)" width="100%" height="100%" />
</div>
